/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { EntityDxpUserMeOrganisation } from '../../Services/console';

/**
 * Replace :tenant in a string with the current tenant in state.
 * @param {string} input The string to update.
 * @export
 * @returns {string} The result string.
 */
export const replaceTenantParam = (input: string): string => {
  const { tenant }: { tenant: EntityDxpUserMeOrganisation } = useConsoleServiceStore.getState();
  return tenant ? input.replace(/:tenant/, tenant.tenantReferenceId) : input;
};
